import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ITreeOptions, TreeComponent, TreeNode, TREE_ACTIONS } from '@circlon/angular-tree-component';

@Component({
  selector: 'ngx-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AdvancedTreeComponent implements OnInit {
  @Input('headerContent') public headerContent: any;
  @Input('customNodeTemplate') public customNodeTemplate: any;
  @Input('treeOptions') public treeOptions: ITreeOptions;
  @Input('nodes') public nodes: any[];
  @Input('alwaysClickEvent') public alwaysClickEvent: boolean = false;
  @Input('enableDoubleClick') public enableDoubleClick: boolean = false;

  @Output('selectItem') public selectItem: EventEmitter<any> = new EventEmitter<any>();
  @Output('refresh') public refresh: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('tree') private tree: TreeComponent;

  selectedNode: any;

  options: ITreeOptions;

  public get treeComponent(): TreeComponent {
    return this.tree;
  }

  public defaultOptions: ITreeOptions = {
    useVirtualScroll: true,
    nodeHeight: 40,
    isExpandedField: 'expanded',
    animateExpand: true, 
    animateSpeed: 30,
    actionMapping: {
      mouse: {
        click: (tree, node, $event) => {
          if (node) {
            TREE_ACTIONS.TOGGLE_ACTIVE(tree, node, $event);

            if (!this.enableDoubleClick)
              this.onSelectedNode(node);
          }
        },
        dblClick: (tree, node, $event) => {
          if (node.hasChildren) TREE_ACTIONS.TOGGLE_EXPANDED(tree, node, $event);

          if (this.enableDoubleClick)
            this.onSelectedNode(node);
        },
      },
    },
  };

  constructor() {}

  onInit() {
    this.tree?.treeModel.collapseAll();
  }

  ngOnInit() {
    this.options = this.treeOptions ? Object.assign(this.treeOptions, this.defaultOptions) : this.defaultOptions;
  }

  onSelectedNode(selectedNode: any) {
    if (!this.alwaysClickEvent && this.selectedNode == selectedNode) {
      console.debug('already selected node');
      return;
    }

    this.selectedNode = selectedNode;
    this.selectItem.emit(this.selectedNode);
  }

  onRefresh() {
    this.refresh.emit();
  }

  collapseAll() {
    this.tree?.treeModel?.activeNodes.forEach((node: TreeNode) => node.toggleActivated());
    this.tree?.treeModel?.clearFilter();
    this.tree?.treeModel?.collapseAll();
  }

  expandAll() {
    this.tree?.treeModel?.activeNodes.forEach((node: TreeNode) => node.toggleActivated());
    this.tree?.treeModel?.clearFilter();
    this.tree?.treeModel?.expandAll();
  }
}
